/* ========================================================================
 * FD:          FD
 * Child:       CONTROL
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * dropdown 
 * ======================================================================== 
 * 8/6/2016: creation
*/

FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    //  element
    var ELEM = '[data-fd="dropdown"]';
    var PARENT = '[data-parent="true"]';


    //  defaults
    var defaults = {
        useparent: true,
        parentid: -1,
        callbackprefix: 1,
        tag: 79,
        value: '',
        relateditem: '',
        noedit: false,

        setdefaultValue: function () {
            var e = $(this.element);
            var value = e.data('value');

            e.children('li').each(function () {
                var a = $(this).find('a');
                var aVal = a.data('value');
                
                if (aVal !== undefined) {
                    if (value === aVal) $(this).addClass('active');
                }            
            });
        }
    };

    /* ========================================================================
     *  private methods
     * ========================================================================
    */


    //  set events
    function setEvents() {
        var NAMESPACE = me.getUID('CTRL_');

        //  set event li a
        $(document).off('click', '[data-fd="dropdown"] li a');
        $(document).on('click.' + NAMESPACE, '[data-fd="dropdown"] li a', function (e) {
            var elem = $(this);
            var parent = elem.parents('ul').first();
            var data = parent.data();

            if (data !== undefined) {
                var isDD = data.isddelem;
                if (isDD !== undefined) {
                    var text = elem.html();
                    var value = elem.data('value') || null;

                    //  set choice text
                    data.relateditem.html(text);

                    parent.children('li').removeClass('active');
                    elem.parent('li').addClass('active');

                    //  value
                    data.value = value;
                    parent.data(data);

                    //  callback
                    me.setCallBackFromData(parent, { e: data.element, value: data.value, tag: data.tag, parentid: data.parentid });
                }
            }        
        });


        //  hidhlight row
        $(document).on("show.bs.dropdown", function(event){
            var elem = $(event.relatedTarget)
            var td = elem.parents('td').first();

            if (td.length) {
                var table = elem.parents('table').first();

                if (table.length > 0) {
                    var row = elem.parents('tr');
                    table.find('tr').removeClass('highlight-child-withborder');

                    row.addClass('highlight-child-withborder');
                }
            }
        });

        $(window).scroll(function () {
            $('.dropdown').removeClass('open');
        });
    }


    //  get dropdown
    function getDropDown(wireEvent, container) {
        var list = '';

        //  set list
        if (container !== null) {
            if (typeof container === 'string') container = $(container);
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }


        //  wire events
        if (wireEvent) setEvents();


        //  bail
        if (list.length === 0) return;

        
        //  element
        list.each(function (i, e) {
            var elem = $(e);

            //  set options
            var options = $.extend({}, defaults, elem.data());

            //  find related item
            options.relateditem = elem.prev('.dropdown-toggle').find('.dropdown-title');
            options.isddelem = true;            //  used in case we have other dd that don't use FD


            //  set elem data
            me.setControlItemOptions(elem, options);


            //  set data
            elem.data(options);

            //  set cursor
            if (!options.noedit) elem.css({ cursor: 'pointer' });

            //  set default value
            elem.data().setdefaultValue();
        });
    }









    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    
    //  set dropdonw
    child.setDropDown = function (wireEvent, container) {
        getDropDown(wireEvent, container);
    }


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));